"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUp = void 0;
class SignUp {
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    execute(request) {
        return this.authenticationService.signUp(request);
    }
}
exports.SignUp = SignUp;
